/**
 *  accounts.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import * as actionTypes from './actionTypes';

export const saveAccount= value => ({
    type: actionTypes.SAVE_ACCOUNT,
    account: value
});

export const clearAccount = value => ({
    type: actionTypes.CLEAR_ACCOUNT,
    account: []
});


// WEBPACK FOOTER //
// ./src/actions/account.js